import React from "react";

export default function Messaging({
  messages,
  message,
  setMessage,
  sendMessage,
  messagesEndRef,
  loading,
}) {
  return (
    <div className="chat-body" id="bd">
      <div
        className="chat-messages"
        id="chatMessages"
        // style={{ background: "red" }}
      >
        {messages.map((item, index) =>
          item.id == 1 ? (
            <div key={index} className="user-message message">
              <span>{item.text}</span>
            </div>
          ) : (
            <div key={index} className="ai-message message">
              <span>{item.text}</span>
            </div>
          )
        )}
        <div ref={messagesEndRef} />
      </div>
      <div className="input-area">
        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          type="text"
          id="chatInput"
          placeholder="Type your message..."
        />
        <button onClick={sendMessage} disabled={loading}>
          {loading ? <div className="loader small"></div> : "Send"}
        </button>
      </div>
    </div>
  );
}
